import { Button, Form, notification, Popconfirm } from "antd";
import React, { useState } from "react";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";
import { addNewTop10Article } from "../action";

type Props = {
  fetchData: () => void;
};

interface FormValues {
  article: {
    en: string;
    ar: string;
    fr: string;
  };
}

const AddNewTop10Article: React.FC<Props> = ({ fetchData }) => {
  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await addNewTop10Article(formValues.article);

      if (data) {
        form.resetFields();
        fetchData();
        api.success({
          message: "Article added successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to add article",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="article" label="Article" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this article?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<PiPlus />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Adding Article..." : "Add Article"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default AddNewTop10Article;
